
import { ActionTypes, IFandfOpAction, IFandfOpState } from 'app/redux/Customers/fandf/reducer'
import { PensionActionCreator } from 'app/redux/Pensions/actions'
import { FandfWorkbookDAO, FandfWorkbookDAOCalculator } from 'app/workbookDAOs/fandfDAO'
import * as _ from 'lodash'

class FandfActionCreator extends PensionActionCreator<IFandfOpState, IFandfOpAction> {
  public workbook: FandfWorkbookDAO

  constructor() {
    super(ActionTypes)

    // This is a kind of a hack- sharing a single Action between different operations. But since
    // we're really after a busy status change, we'll see if we can live with it
    this.workbook = new FandfWorkbookDAO(this)
  }

}

const FandfActions = new FandfActionCreator()
const cachedFandfRunCalculations = _.memoize(FandfActions.workbook.runCalculations.bind(FandfActions.workbook), JSON.stringify) as FandfWorkbookDAOCalculator

export {
  FandfActions,
  FandfActionCreator,

  cachedFandfRunCalculations
}



// WEBPACK FOOTER //
// ./src/app/redux/Customers/Fandf/actions/index.ts